var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5816 27.104C25.3072 27.2901 25.1429 27.6001 25.1429 27.9316V31H16.8571L16.8571 27.9316C16.8571 27.6001 16.6928 27.2901 16.4184 27.104C14.3429 25.6965 13 23.3704 13 20.75C13 16.4962 16.555 13 21 13C25.445 13 29 16.4962 29 20.75C29 23.3704 27.6571 25.6965 25.5816 27.104Z",
    stroke: "#EDEEF1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 23,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(-90 0 23)",
    fill: "#EDEEF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(-90 34 23)",
    fill: "#EDEEF1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4141,
    y: 12.071,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(-135 31.4141 12.071)",
    fill: "#EDEEF1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0713,
    y: 10.6567,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(135 12.0713 10.6567)",
    fill: "#EDEEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 35C16 34.4477 16.4477 34 17 34H25C25.5523 34 26 34.4477 26 35C26 35.5523 25.5523 36 25 36H17C16.4477 36 16 35.5523 16 35Z",
    fill: "#EDEEF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39C18 38.4477 18.4477 38 19 38H23C23.5523 38 24 38.4477 24 39C24 39.5523 23.5523 40 23 40H19C18.4477 40 18 39.5523 18 39Z",
    fill: "#EDEEF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#EDEEF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbOff);
export default __webpack_public_path__ + "static/media/lightbulb_off.d9642491468a1f42a0f1548a1296626b.svg";
export { ForwardRef as ReactComponent };